import { PHONE_APPOINTMENT_TYPE } from "../models/phone-appointment";

export type AppointmentScrollKind = "screening" | "phone";

export const UPCOMING_APPOINTMENTS_SECTION_ID = "upcoming-appointments-section";

export function getAppointmentElementId(
    appointmentId: number,
    kind: AppointmentScrollKind = "screening"
): string {
    const prefix = kind === "phone" ? PHONE_APPOINTMENT_TYPE : "appointment";

    return `${prefix}-${appointmentId}`;
}

export function getAppointmentScrollTarget(
    appointmentId?: number,
    kind: AppointmentScrollKind = "screening"
): HTMLElement | null {
    if (!appointmentId) {
        return null;
    }

    return (
        document.getElementById(getAppointmentElementId(appointmentId, kind)) ??
        document.getElementById(UPCOMING_APPOINTMENTS_SECTION_ID)
    );
}

export function scrollToAppointment(
    appointmentId?: number,
    kind: AppointmentScrollKind = "screening"
): boolean {
    const target = getAppointmentScrollTarget(appointmentId, kind);

    if (!target) {
        return false;
    }

    target.scrollIntoView({
        behavior: "smooth",
        block: "start",
    });

    return true;
}
